import SelectedContactsList from './SelectedContactsList';

export default SelectedContactsList;
